import { useForm } from "react-hook-form";
import { DispatchTransactionEvent } from "../../components/events/events";
import { EVENT_TOPIC_FOR_DATAFEED_SERVER, EVENT_TOPIC_FOR_TRANSACTION_SERVER, 
         EVENT_TYPE_DATAFEED_LOGON, EVENT_TYPE_TRANSACTION_LOGON, 
         JSON_KEY_IN_SEQ, 
         JSON_KEY_MESSAGE_TYPE, JSON_KEY_PASSWORD, JSON_KEY_SUBMITTER, JSON_KEY_USER, 
       } from "../../common/common";
import { useDispatch } from "react-redux";
import { setTSUserId, setDFUserId } from "../../redux/globalsSlice";
import { MSGTYPE_DF_LOGON, MSGTYPE_TS_LOGON } from "../../common/msg_types";

// ✅ Local reusable FormInput component
const FormInput = ({ label, placeholder, name, type = "text", register, required = true }) => (
  <div className="form-group">
    <label className="form-label">{label}</label>
    <input
      type={type}
      className="form-control"
      placeholder={placeholder}
      required={required}
      {...register(name, { required: true })}
    />
  </div>
);

export const LoginForm = () => {
  const dispatch = useDispatch();
  const all_in_one_server = window.APP_CONFIG.ALL_IN_ONE_SERVER;

  const { register, handleSubmit } = useForm({
    mode: "onChange",
    // defaultValues: {
    //   tsuser: configData.TRANSACTION_USER_ID,
    //   tspassword: configData.TRANSACTION_PASSWORD,
    //   dfuser: configData.DATAFEED_USER_ID,
    //   dfpassword: configData.DATAFEED_PASSWORD,
    // },
  });

  const onSubmit = (data) => {
    dispatch(setTSUserId(data.tsuser));
    dispatch(setDFUserId(data.dfuser));

    if (!all_in_one_server) {
      const df_login = {
        [JSON_KEY_MESSAGE_TYPE]: MSGTYPE_DF_LOGON,
        [JSON_KEY_USER]: data.dfuser,
        [JSON_KEY_IN_SEQ]: 0,
        [JSON_KEY_SUBMITTER]: data.dfuser,
        [JSON_KEY_PASSWORD]: data.dfpassword,
      }
      console.log("Dispatched event for TSConnection:", data);
      DispatchTransactionEvent(EVENT_TOPIC_FOR_DATAFEED_SERVER, EVENT_TYPE_DATAFEED_LOGON, df_login);
    }

    const ts_login = {
      [JSON_KEY_MESSAGE_TYPE]: MSGTYPE_TS_LOGON,
      [JSON_KEY_USER]: data.tsuser,
      [JSON_KEY_IN_SEQ]: 0,
      [JSON_KEY_SUBMITTER]: data.tsuser,
      [JSON_KEY_PASSWORD]: data.tspassword,
    }
    DispatchTransactionEvent(EVENT_TOPIC_FOR_TRANSACTION_SERVER, EVENT_TYPE_TRANSACTION_LOGON, ts_login);
    };

  return (
    <>
      <form className="window-center" onSubmit={handleSubmit(onSubmit)}>
        <h3 className="form-title">CTS Sign In</h3>
        <FormInput
          label="User Id"
          placeholder="Enter User Id"
          name="tsuser"
          register={register}
        />
        <FormInput
          label="Password"
          placeholder="Enter Password"
          name="tspassword"
          type="password"
          register={register}
        />
        {!all_in_one_server && (
          <>
            <FormInput
              label="Datafeed User Id"
              placeholder="Enter Datafeed User Id"
              name="dfuser"
              register={register}
            />
            <FormInput
              label="Datafeed Password"
              placeholder="Enter Datafeed Password"
              name="dfpassword"
              type="password"
              register={register}
            />
          </>
        )}
        <div className="single-button">
          <button type="submit" className="btn btn-primary">
            Logon
          </button>
        </div>
      </form>
    </>
  );
};
